
import { FunnelsServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      deletedFunnels: [],
      restoreInProgress: false,
      loadingFunnel: false
    };
  },
  methods: {
    async fetchAllDeletedFunnels() {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.loadingFunnel = true;
        const { data } = await FunnelsServices.getDeletedFunnel({
          locationId: this.locationId
        });
        this.deletedFunnels = data.funnels;
        this.loadingFunnel = false;
      } catch (error) {
        console.log(error);
        this.loadingFunnel = false;
      }
    },
    async restoreFunnel(funnel: any) {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.restoreInProgress = true;
        await FunnelsServices.restoreFunnel({
          locationId: this.locationId,
          funnelId: funnel.id
        });
        this.fetchAllDeletedFunnels();
        this.restoreInProgress = false;
      } catch (error) {
        console.error(error);
        this.restoreInProgress = false;
      }
    }
  }
});
